/* ============================================================
   VIENTRE DE PAPEL – TRÍPTICO (Pack 10 / Pack 20)
   - Varianti Shopify dal DOM
   - Cambio variante automatico
   - Cambio prezzo live
   - Descrizione dinamica
   - Solo dropdown "¿Embarazo de cuántos hijos?"
   - Gestione quantità (nessun campo bebé)
   ============================================================ */

document.addEventListener("DOMContentLoaded", function () {

  const wrapper  = document.querySelector(".vp-triptico-wrapper");
  if (!wrapper) return;

  const botones  = wrapper.querySelectorAll(".vp-boton-tipo");
  const priceEl  = document.querySelector(".price-item--regular");
  const descZone = document.querySelector("#vp-descripcion-triptico");
  const detalles = document.querySelector("#vp-detalles-triptico");
  
  function parseVariantPrice(value) {
    return parseFloat(String(value || "").trim().replace(",", "."));
  }

  /* ------------------------------------------------------------
     1 — LEGGIAMO LE VARIANTI DAL DOM
     ------------------------------------------------------------ */
  function loadVariantPrices() {
    const variantes = Array.from(document.querySelectorAll("[data-product-variant]"));
    const map = {};

    variantes.forEach(v => {
      const id    = parseInt(v.dataset.variantId, 10);
      const price = parseVariantPrice(v.dataset.variantPrice);
      const opt   = v.dataset.variantOption?.toLowerCase().trim();

      if (opt.includes("20")) {
        map.pack20 = { id, price };
      } else {
        map.pack10 = { id, price };
      }
    });

    return map;
  }

  const VP_TRIPTICO = loadVariantPrices();

  /* ------------------------------------------------------------
     2 — FUNZIONI UTILI
     ------------------------------------------------------------ */
  function tipoActivo() {
    const activo = wrapper.querySelector(".vp-boton-tipo.is-active");
    if (!activo) return "pack10";

    return activo.dataset.tipo.includes("20") ? "pack20" : "pack10";
  }

  function getVariantInput() {
    return document.querySelector('product-form form input[name="id"]');
  }

  function getQtyInput() {
    return document.querySelector('input[name="quantity"]');
  }

  function cantidad() {
    const input = getQtyInput();
    const v = input ? parseInt(input.value, 10) : 1;
    return !v || v < 1 ? 1 : v;
  }

  /* ------------------------------------------------------------
     3 — CAMBIO VARIANTE + PREZZO
     ------------------------------------------------------------ */
  function updateVariantAndPrice() {
    const idInput = getVariantInput();
    const tipo = tipoActivo();
    const varData = VP_TRIPTICO[tipo];

    if (!idInput || !varData || !priceEl) return;

    idInput.value = varData.id;

    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* ------------------------------------------------------------
     4 — DESCRIZIONE DINAMICA
     ------------------------------------------------------------ */
  function renderDescripcion() {
    descZone.innerHTML = `
      <p>Este tríptico es el aliado ideal para recibir visitas con tranquilidad. 
      Reúne pautas sencillas como higiene, respeto al descanso y apoyo emocional 
      para que las personas que os visitan sepan cómo acompañar de forma amable y respetuosa.</p>

      <p>Un recurso práctico que ayuda a que mamá y bebé se sientan tranquilos, 
      cuidados y protegidos desde el primer momento.</p>
    `;
  }

  /* ------------------------------------------------------------
     5 — GENERAZIONE CAMPI DINAMICI (SOLO dropdown hijos)
     ------------------------------------------------------------ */
  function renderDetalles() {
    const cant = cantidad();
    let html = "";

    for (let i = 1; i <= cant; i++) {
      html += `
        <div class="vp-pack-bloque">
          <h4 class="vp-pack-titulo">Pack de Tríptico ${i}</h4>

          <label class="vp-label-campo">¿Esperas uno o más bebés?</label>
          <select name="properties[Tríptico ${i} - Bebés]"
                  class="vp-select hijos-select">
            <option value="1 bebé">1 bebé</option>
            <option value="Más de 1 bebé">Más de 1 bebé</option>
          </select>
        </div>
      `;
    }

    detalles.innerHTML = html;
  }

  /* ------------------------------------------------------------
     6 — EVENTI
     ------------------------------------------------------------ */
  botones.forEach(btn => {
    btn.addEventListener("click", () => {
      botones.forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      updateVariantAndPrice();
      renderDescripcion();
      renderDetalles();
    });
  });

  document.body.addEventListener("input", e => {
    if (e.target.matches('input[name="quantity"]')) renderDetalles();
  });

  document.body.addEventListener("click", e => {
    if (e.target.closest(".quantity__button")) {
      setTimeout(renderDetalles, 50);
    }
  });

  /* INIT */
  updateVariantAndPrice();
  renderDescripcion();
  renderDetalles();
});
